import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '@shared/shared-providers';
import { MediaLibraryService } from '../../../../shared/services/media-library.service';
import { SnackBarService } from '../../../../shared/services';
import { TranslateService } from '@ngx-translate/core';

export interface CcPreviewModalData {
  outputFile: string;
  name: string;
  originalAssetName?: string;
}

@Component({
  selector: 'app-cc-preview-modal',
  templateUrl: './cc-preview-modal.component.html',
  styleUrls: ['./cc-preview-modal.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS],
})
export class CcPreviewModalComponent {
  private dialogRef = inject(MatDialogRef<CcPreviewModalComponent>);
  data: CcPreviewModalData = inject(MAT_DIALOG_DATA);
  private mediaLibraryService = inject(MediaLibraryService);
  private snackBarService = inject(SnackBarService);
  private translateService = inject(TranslateService);

  saving = signal(false);

  get videoUrl(): string {
    return this.mediaLibraryService.getFullAssetUrl(this.data.outputFile);
  }

  save(): void {
    if (this.saving()) return;
    this.saving.set(true);

    this.mediaLibraryService.saveGeneratedCCToLibrary(this.data.outputFile, this.data.name).subscribe({
      next: () => {
        this.snackBarService.showWithText(
          this.translateService.instant('media_library.cc.saveSuccess'),
          'success'
        );
        this.dialogRef.close({ saved: true });
      },
      error: (err) => {
        // 400 "already exists" is acceptable — asset is in the DB
        if (err?.status === 400) {
          this.snackBarService.showWithText(
            this.translateService.instant('media_library.cc.saveSuccess'),
            'success'
          );
          this.dialogRef.close({ saved: true });
        } else {
          this.saving.set(false);
          this.snackBarService.showWithText(
            this.translateService.instant('media_library.cc.saveError'),
            'fail'
          );
        }
      },
    });
  }

  discard(): void {
    this.dialogRef.close({ saved: false });
  }
}
